import { Filters } from '@3ddv/ngx-sites-builder-lib';
import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-menucolors',
  templateUrl: './menucolors.component.html',
  styleUrls: ['./menucolors.component.scss']
})
export class MenucolorsComponent implements OnInit {
  @Input() tool : Filters;
  constructor() { }

  ngOnInit(): void {
  }

}
